import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableLimitSelectorComponent } from './table-limit-selector.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [TableLimitSelectorComponent],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [TableLimitSelectorComponent],
})
export class TableLimitSelectorModule {
}
